<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :excluded-filter-fields="excludeFilterFields"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="event/admin/survey/"
                       data-key="surveys"
                       :extra-params="{event_id: eventId}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.start="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.end="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.quota="{value}">
      {{ value === -1 ? 'N/A' : value }}
    </template>
    <template #item.actions="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="file-export"
                             @click.stop="exportSurveyResponse(item)"></font-awesome-icon>
        </v-col>
        <v-col>
          <font-awesome-icon icon="edit"
                             @click.stop="editItem(item)"></font-awesome-icon>
        </v-col>
        <v-col>
          <font-awesome-icon icon="trash"
                             @click.stop="deleteItem(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import _ from 'lodash';

library.add(faEdit, faSearch);

export default {
  name: 'SurveyList',
  components: {RemotePaginatedList},
  props: {
    showSelect: Boolean,
    excludeFilterFields: Array,
    refreshTrigger: Boolean,
    eventId: String,
    value: Array,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Filter
    const filterOptions = computed(() => {
      return []
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_survey.title_en'), value: 'title_en'},
      {text: root.$t('admin_survey.title_zh'), value: 'title_zh'},
      {text: root.$t('admin_survey.start'), value: 'start'},
      {text: root.$t('admin_survey.end'), value: 'end'},
      {text: root.$t('admin_survey.response_count'), value: 'response_count', sortable: false},

      {text: '', value: 'actions', sortable: false, width: 100},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const exportSurveyResponse = function (survey) {
      root.$downloadFile('event/admin/survey/export/', {survey_id: survey.id},
          survey.title + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    };
    const editItem = function (item) {
      emit('edit', item);
    };
    const deleteItem = function (item) {
      if (confirm(root.$t('admin_survey.delete_msg'))) {
        root.$callAPI('event/admin/survey/delete/', {survey_id: item.id}, function () {
          refresh();
        });
      }
    };

    return {
      filterOptions,
      headers,
      innerRefreshTrigger,

      selectedItemIds,

      exportSurveyResponse,
      editItem,
      deleteItem,
    }
  },
}
</script>
